export const GET_ADMIN_STRUCTURE_TYPES_PRODUCTS =
  '/admin/structure-types-products'
